// extracted by mini-css-extract-plugin
export default {"validation_wrap":"ContainerCreate_validation_wrap__OBnhJ"};